import { watch } from 'vue'

/** How long a confirm waits for its new stamp to come back before it moves on anyway. */
export const CONFIRM_STAMP_WAIT_MS = 8000

/** Resolves once a reactive value differs from `from`, or after `timeoutMs`. */
export function whenChanged<T>(read: () => T, from: T, timeoutMs: number): Promise<void> {
  if (read() !== from) return Promise.resolve()
  return new Promise((resolve) => {
    const stop = watch(read, (value) => {
      if (value !== from) done()
    })
    const timer = setTimeout(done, timeoutMs)
    function done(): void {
      clearTimeout(timer)
      stop()
      resolve()
    }
  })
}
